import React from "react";
import LegalPage from "./LegalPage";

const SECTIONS = [
  {
    heading: "Use of this website",
    body:
      "By accessing this website you agree to use it for lawful purposes and in a way that does not infringe the rights of, restrict or inhibit anyone else's use of it.",
  },
  {
    heading: "Nature of services",
    body:
      "Verified Workforce is a specialist subcontractor sourcing and vetting service. We are not a recruitment agency and are not a labour-only provider. We connect developers, main contractors and housing associations with vetted specialist subcontractors.",
  },
  {
    heading: "Content",
    body:
      "All content on this website is provided for general information only. While we take reasonable care to ensure accuracy, we make no warranties, express or implied.",
  },
  {
    heading: "Limitation of liability",
    body:
      "Verified Workforce will not be liable for any indirect, incidental, or consequential damages arising out of your use of the site or of any services introduced through it.",
  },
  {
    heading: "Governing law",
    body:
      "These terms are governed by the laws of England and Wales. Any disputes will be subject to the exclusive jurisdiction of the courts of England and Wales.",
  },
  {
    heading: "Contact",
    body:
      "Questions about these Terms can be sent to Robert@verifiedworkforce.co.uk.",
  },
];

export default function Terms() {
  return <LegalPage title="Terms of Use" sections={SECTIONS} />;
}
